export enum ServiceTypeActionType{
  FETCH_SERVICE_TYPES = "FETCH_SERVICE_TYPES",
  FETCH_SERVICE_TYPE_REQUEST = "FETCH_SERVICE_TYPE_REQUEST",
  FETCH_SERVICE_TYPE_SUCCESS = "FETCH_SERVICE_TYPE_SUCCESS",
  FETCH_SERVICE_TYPE_ERROR = "FETCH_SERVICE_TYPE_ERROR",
}